<template>
    <div>
        <div class="mt-5 filter-column">
            <page-filter-city :page-filter-type="'cinema'"
                              :id-prefix="idPrefix"
                              :icon="'fas fa-map-pin'"
                              :plural="'Steden'"
                              :input-name="'city'"
                              :items="[]"
            ></page-filter-city>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            idPrefix: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
            };
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/cinemas/CinemaFilters.vue